import { format } from 'date-fns'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { getLastBusinessDayOfMonth } from '@utils/date.utils'

import { SubscriptionRequest } from '@model/TradingPlatformsDto'

interface Props {
  subscriptionRequest?: SubscriptionRequest
  onConfirm: (subscriptionRequest?: SubscriptionRequest) => void
}

export const UnsubscribeConfirmationModal: BaseModalType<Props> = (props) => {
  const { subscriptionRequest, onConfirm, close } = props

  const { t } = useTranslation()
  const [auth] = useContext(AuthSessionContext)
  const dateFormat = auth?.dateFormatType.name

  const lastBusinessDayOfMonth = getLastBusinessDayOfMonth().getDate()
  const dates = format(lastBusinessDayOfMonth, dateFormat || 'yyyy-MM-dd')

  return (
    <Modal>
      <Modal.Header>{t('Market Data.Attention')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Market Data.unsubscribe confirmation 1')}</Modal.Body.Text>
        <Modal.Body.Text>
          {t('Market Data.unsubscribe confirmation 2', {
            dates,
          })}
        </Modal.Body.Text>
        <Modal.Body.Text>{t('Market Data.unsubscribe confirmation 3')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>
          {t('Market Data.Keep subscription')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={() => onConfirm(subscriptionRequest)}>
          {t('Market Data.Yes, unsubscribe')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
